/**
 * `van_style` keys the Alpha data API rejects in the `body_type` / `car_style` filter (422),
 * even though the vehicle catalogue publishes them. Offering them would break the whole request,
 * so they are dropped from the body style options.
 *
 * `all_cars` and `all_auctions` validate the filter against the same enum, so the list holds for
 * both tabs. Measured against Alpha stage on 2026-09-24 (T20-138142). Remove a key once Alpha
 * accepts it.
 */
export const UNSUPPORTED_VAN_BODY_STYLE_KEYS: readonly string[] = [
  'VANSTYLE_PICKUP',
  'VANSTYLE_CONTAINER',
  'VANSTYLE_FLATBED_TIPPER',
  'VANSTYLE_FIRE_TRUCK',
  'VANSTYLE_OTHER',
];
